<template>
  <v-card>
    <v-layout column>
      <v-toolbar card  light dense flat>
      <v-toolbar-title>{{title}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-flex v-show="cxt.isFilterMode()" sm4 xs4 >
        <v-text-field
          autofocus
          label="Фильтр"
          v-show="cxt.isFilterMode()"
          v-model="cxt.filterString"
          solo flat
        ></v-text-field>
      </v-flex>
      <v-btn icon @click="cancel">
        <v-icon>close</v-icon>
      </v-btn>
      </v-toolbar>
      <v-card-scroll md flat :height="calcDialogScroll(48+52)">
      <v-calc-panel v-model="calc">
      </v-calc-panel>
      <v-card :height="fillHeight ? '100%' : 'auto'">
        <v-panel-title @click="showDetails=!showDetails" :value="this.showDetails" :caption="this.showDetails ? 'Кратко' : 'Подробно'" :expandable="true">
          <span>Сумма основного долга: <b>{{ formats.blank(calc.result.sum, formats.formatNumber)}} руб.</b></span>
          <span>Сумма процентов: <b>{{ formats.blank(calc.result.profit, formats.formatNumber)}} pуб.</b></span>
          <span>ИТОГО: <b>{{ formats.blank(calc.result.total, formats.formatNumber)}} pуб.</b></span>
          <br/>
          <span>Гос. пошлина: <b>{{ formats.blank(calc.result.duties, formats.formatNumber)}} pуб.</b></span>
        </v-panel-title>
        <v-card-text v-show="showDetails">
          <table class="report_table" border="1" style="width: 100%; min-width: 500px; border-collapse:collapse;" cellpadding="">
            <tbody>
              <tr>
                <th>Cумма операции, в&nbspруб.</th>
                <th>Долг, в&nbspруб.</th>
                <th>С</th>
                <th>По</th>
                <th>Дней</th>
                <th>Ставка</th>
                <th>Неустойка</th>
              </tr>
              <template v-for="item in calc.details">
              <tr v-if="item.amount > 0">
                <td style="text-align: right;">{{formats.blank(item.amount, formats.formatNumber)}}</td>
                <td></td>
                <td>{{formatDate(item.start)}}</td>
                <td colspan="3">{{formatNote(item.ref)}}</td>
                <td></td>
              </tr>
              <tr v-if="item.amount < 0">
                <td style="text-align: right;">{{formats.blank(item.sum, formats.formatNumber)}}</td>
                <td></td>
                <td>{{formatDate(item.start)}}</td>
                <td colspan="3">{{formatNote(item.ref)}} на {{formats.blank(item.amount, formats.formatNumber)}}</td>
                <td style="text-align: right;">{{item.profit ? formats.blank(item.profit, formats.formatNumber) : ''}}</td>
              </tr>
              <tr v-if="item.amount == null">
                <td></td>
                <td style="text-align: right;">{{formats.blank(item.sum, formats.formatNumber)}}</td>
                <td>{{formatDate(item.start)}}</td>
                <td>{{formatDate(item.end)}}</td>
                <td style="text-align: right;">{{formats.blank(item.days, formatNumber)}}</td>
                <td style="text-align: right;">{{formats.blank(item.rate, formatPercent)}}</td>
                <td style="text-align: right;">{{formats.blank(item.profit, formatNumber)}}</td>
              </tr>
              </template>
            </tbody>
          </table>
        </v-card-text>
      </v-card>
    </v-card-scroll>
    <v-card-actions>
      <v-btn @click="ok()">Сохранить</v-btn>
      <!-- <v-btn @click="loadDocs()">Загрузить</v-btn> -->
      <v-spacer></v-spacer>
      <v-ops-btn :cxt="cxt"></v-ops-btn>
    </v-card-actions>
  </v-layout>
  </v-card>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import apimix from '../../common/apimix'
  import server from '../../../api/server'
  import classes from '../../../api/classes'
  import vCardScroll from '../../common/CardScroll'
  import vOpsBtn from '../../common/OpsBtn'
  import vCalcPanel from './CalcPanel'
  import dialogs from '../../../components/common/dialogs'
  import vCSVLoader from './CalcCSVLoader'
  import vCSV1SLoader from './CalcCSV1SLoader'
  import vPanelTitle from '../../info/PanelTitle'

  export default {
    name: 'calc-form',
    components: {vCardScroll, vOpsBtn, vCalcPanel, vPanelTitle},
    mixins: [apimix],
    data: () => ({
      cxt: null,
      fillHeight: true,
      showDetails: false,
      calc: null
    }),
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      radio: {
        type: Boolean,
        default: false
      },
      selected: {
        type: Array,
        default: function () {
          return []
        }
      },
      value: {
        type: Object,
        default: null
      },
      title: {
        type: String,
        default: 'Список документов'
      },
      companyRefCode: {
        type: String,
        default: null
      }
    },
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => this.getItemKey(item))
      })
      // cxt.mode = classes.modes.SELECT
      cxt.actionCaption = 'Операции'
      // // cxt.actions.push({divider: true})
      // // cxt.actions.push(new classes.SelectAction(cxt))
      // cxt.actions.push({divider: true})
      cxt.actions.push(new classes.Action(this, 'Загрузить из 1C XSLX файла',
        null,
        () => this.loadOps1S()))
      cxt.actions.push(new classes.Action(this, 'Загрузить из CSV файла',
        null,
        () => this.loadOps()))
      cxt.actions.push(new classes.Action(this, 'Рассчитать',
        null,
        () => this.calculate()))
      this.cxt = cxt
      if (this.selected != null) {
        this.selected.forEach(id => this.cxt.select(id))
      }
      this.calc = this.init()
    },
    mounted () {
      this.fetchData()
    },
    watch: {
      value: function (newVal, oldVal) { // watch it
        this.fetchData()
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        calcDialogScroll: 'calcDialogScroll'
      }),
      orderedItems () {
        // console.log('orderedItems', this.items)
        return this.items.sort((a, b) => this.getItemTitle(a) ? this.getItemTitle(a).localeCompare(this.getItemTitle(b)) : -1)
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(this.getItemTitle(item))
            .concat(this.getItemText(item))
        }
        var filter = (!this.cxt.isFilterMode()) || (this.cxt.filterString === null) || (this.cxt.filterString.length < 3) ? null : this.cxt.filterString.toUpperCase()
        if (!filter) {
          return this.orderedItems
        }
        return this.orderedItems.filter(item => {
          return getSearchString(item).toUpperCase().includes(filter)
        })
      }
    },
    methods: {
      init () {
        return {
          params: {
            start: null,
            end: null,
            lateDays: 0,
            rates: [{from: 1, percent: 0.1}],
            calcType: 'CONTRACT',
            startType: 'DELAY',
            periodType: 'DAYS_365',
            minusType: 'BASE_ONLY',
            rateType: 'DAY',
            dutyType: 'ARBITR'
          },
          loans: [],
          pays: [],
          details: [],
          result: {
            sum: null,
            percent: null,
            total: null,
            duties: null
          }
        }
      },
      getItemKey (item) {
        return item.uid
      },
      fetchData () {
        if (this.value) {
          this.calc = Object.assign(this.calc, this.value)
          if (this.calc.params && this.calc.params.start && this.calc.params.end && this.calc.loans.length + this.calc.pays.length > 0) {
            this.calculate()
          }
        }
      },
      ok () {
        this.calculate().then(() => {
          this.$emit('input', Object.assign(this.calc, {details: [], result: {}}))
          this.cancel()
        })
      },
      cancel () {
        this.$emit('close')
        this.itemId = null
      },
      select (uid) {
        if (this.cxt.uncheck(uid)) {
          if (this.radio) {
            this.cxt.clear()
          }
        }
        this.cxt.select(uid)
      },
      click (item) {
      },
      onChangeFilter (e) {
        this.cxt.filterString = e
      },
      getItemTitle (item) {
        return item.docName
      },
      getItemText (item) {
        return item.uid
      },
      loadFrom () {
        return new Promise((resolve, reject) => {
          dialogs.register('v-csv-loader', vCSVLoader)
          let listFields = []
          listFields.push({name: 'key', label: 'Уникальный ключ', number: 0, type: 'TEXT', key: true})
          listFields.push({name: 'date', label: 'Дата операции', number: 0, type: 'DATE'})
          listFields.push({name: 'note', label: 'Название операции', number: 1, type: 'TEXT'})
          listFields.push({name: 'loan', label: 'Увеличение долга', number: 2, type: 'NUMBER'})
          listFields.push({name: 'pay', label: 'Уменьшение долга', number: 3, type: 'NUMBER'})
          var fullscreen = this.isMobile
          // var fullscreen = false
          var comp = { template: `
            <v-csv-loader
            v-on:close="$emit('close')"
            v-on:change="onChange"
            :fields="fields"
            :keyField="keyField"
            :fullscreen="fullscreen"></v-csv-loader>
            `,
            data () {
              return {
                fullscreen: fullscreen,
                onChange: (data) => resolve(data),
                fields: listFields,
                keyField: 'key'
              }
            }}
          dialogs.modal(comp)
        })
      },
      loadOps () {
        this.loadFrom()
        .then(values => {
          if (values && Object.values(values)) {
            let ops = []
            Object.values(values).forEach(r => {
              ops.push({code: r.loan ? 'LOAN' : 'PAY', date: r.date, amount: r.loan ? Math.abs(r.loan) : Math.abs(r.pay), note: r.note})
            })
            ops = ops.sort((a, b) => a.date ? a.date.localeCompare(b.date) : -1)
            if (ops.length > 0) {
              let op = ops[0]
              this.calc.params.startType = 'RELEASE'
              this.calc.loans = ops.filter((op) => op.code === 'LOAN')
              this.calc.pays = ops.filter((op) => op.code === 'PAY')
              this.calc.params.start = op.date
              this.calc.params.end = this.formats.formatDateToISO(new Date())
            }
            this.calculate()
          }
        })
      },
      loadFrom1S () {
        return new Promise((resolve, reject) => {
          dialogs.register('v-csv1s-loader', vCSV1SLoader)
          let listFields = []
          listFields.push({name: 'key', label: 'Уникальный ключ', number: 0, type: 'TEXT', key: true})
          listFields.push({name: 'date', label: 'Дата операции', number: 0, type: 'DATE'})
          listFields.push({name: 'note', label: 'Название операции', number: 1, type: 'TEXT'})
          listFields.push({name: 'loan', label: 'Увеличение долга', number: 2, type: 'NUMBER'})
          listFields.push({name: 'pay', label: 'Уменьшение долга', number: 3, type: 'NUMBER'})
          var fullscreen = this.isMobile
          // var fullscreen = false
          var comp = { template: `
            <v-csv1s-loader
            v-on:close="$emit('close')"
            v-on:change="onChange"
            :fields="fields"
            :fullscreen="fullscreen"></v-csv1s-loader>
            `,
            data () {
              return {
                fullscreen: fullscreen,
                onChange: (data) => resolve(data),
                fields: listFields
              }
            }}
          dialogs.modal(comp)
        })
      },
      loadOps1S () {
        this.loadFrom1S()
        .then(values => {
          if (values && Object.values(values)) {
            let ops = []
            Object.values(values).forEach(r => {
              ops.push({code: r.loan ? 'LOAN' : 'PAY', date: r.date, amount: r.loan ? Math.abs(r.loan) : Math.abs(r.pay), note: r.note})
            })
            ops = ops.sort((a, b) => a.date ? a.date.localeCompare(b.date) : -1)
            if (ops.length > 0) {
              let op = ops[0]
              this.calc.params.startType = 'RELEASE'
              this.calc.loans = ops.filter((op) => op.code === 'LOAN')
              this.calc.pays = ops.filter((op) => op.code === 'PAY')
              this.calc.params.start = op.date
              this.calc.params.end = this.formats.formatDateToISO(new Date())
            }
            this.calculate()
          }
        })
      },
      calcRequest (request) {
        return new Promise((resolve, reject) => {
          server.apiPost(
            '/openapi/calc-requests',
            Object.assign(request, {details: [], result: {}}),
            (data) => {
              resolve(data)
            },
            (e) => {
              this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при расчете задолжностей '})
              reject(e)
            }
          )
        })
      },
      calculate () {
        return new Promise((resolve, reject) => {
          this.calcRequest(this.calc)
          .then(data => {
            this.calc = data
            resolve()
          })
        })
      },
      formatNote (value) {
        return value != null ? '(' + value + ')' : ''
      },
      formatDate (isoDate) {
        return this.formats.formatDate(isoDate)
      },
      formatPercent (num) {
        return num != null ? (num).toLocaleString(this.locale(), {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' : '-'
      },
      formatNumber (num) {
        if (Math.abs(num) < 0.005) {
          num = 0.004
        }
        return num != null ? num.toLocaleString(this.locale(), {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '-'
      },
      formatCurrency (num) {
        return num != null ? num.toLocaleString(this.locale(), {minimumFractionDigits: 0, maximumFractionDigits: 2}) : '-'
      },
      locale () {
        return navigator.languages && navigator.languages.length > 0 ? navigator.languages[0] : 'en-en'
      }
    }
  }
</script>
<style>
  table.report_table {
    width: 100%;
    border-color: #e0e0e0;
    border-top-width:  0px;
    border-left-width: 0px;
    border-right-width:  0px;
    border-bottom-width:  0px;
  }
  table.report_table td, th {
    padding-left: 2px;
    padding-right: 2px;
  }
  table.report_table th {
    background-color: #F0F0F0;
    vertical-align: top;
    text-align: left;
  }
  table.report_table td {
    vertical-align: top;
    text-align: left;
  }
</style>





// WEBPACK FOOTER //
// CalcForm.vue?2e05d752